import { VerifyResponse, VerifyApiOptions } from '../../shared/models/verify';
import EnrouteApiClient from '../../shared/services/enroute-api-client';
import { mapAxiosResponse } from '../../shared/utils/api-utils';
import AuthUtils from '../../shared/utils/auth-utils';

export default class VerifyService {
  public static async verify(options: VerifyApiOptions): Promise<VerifyResponse> {
    const verifyResponse = await EnrouteApiClient.post('/linkage/validate', {
      code: options.code,
      caller_id: process.env.ORGANIZATION_VERIFICATION_CALLER_ID,
    });

    const response = mapAxiosResponse<VerifyResponse>(verifyResponse);

    const accessTokenExpiration = String(Date.now() + response.expires_in * 1000);
    AuthUtils.setAccessToken(response.access_token);
    AuthUtils.setAccessTokenExp(accessTokenExpiration);

    return response;
  }
}
